// アカウント選択画面（Presentation）
//
// accountId 未選択時の分岐先。ここでアカウントを選ぶまでは
// カスタムダッシュボードのデータ取得を発火させないための画面。

import { Card, CardContent, CardDescription, CardHeader } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import type { SimpleAccount } from '@/lib/types';
import { AccountCommand } from './AccountCommand';

export interface AccountSelectScreenProps {
  accounts: SimpleAccount[];
  isLoading: boolean;
  error: unknown;
  onSelect: (code: string) => void;
  /** お気に入りのアカウント ID。先頭の「お気に入り」欄に出す。 */
  favoriteAccountIds?: string[];
  onToggleFavorite?: (accountId: string, shouldBeFavorite: boolean) => void;
}

export function AccountSelectScreen({
  accounts,
  isLoading,
  error,
  onSelect,
  favoriteAccountIds = [],
  onToggleFavorite,
}: AccountSelectScreenProps) {
  return (
    <div className="flex justify-center px-4 py-14">
      <Card className="w-full max-w-[640px]">
        <CardHeader className="pb-4">
          <h1 className="text-xl font-semibold leading-none tracking-tight">アカウントを選択</h1>
          <CardDescription>
            ダッシュボードを表示するアカウントを、会社名かアカウントコードで検索して選びます
          </CardDescription>
        </CardHeader>
        <CardContent>
          {isLoading && <Skeleton className="h-[480px] w-full" />}

          {!isLoading && error != null && (
            <div className="rounded-md border border-danger/30 bg-danger-muted px-4 py-3 text-sm text-danger">
              アカウント一覧の取得に失敗しました:{' '}
              {error instanceof Error ? error.message : String(error)}
            </div>
          )}

          {!isLoading && error == null && accounts.length === 0 && (
            <p className="text-sm text-muted-foreground">
              選択できるアカウントがありません。アカウントを登録してから再度お試しください
            </p>
          )}

          {!isLoading && error == null && accounts.length > 0 && (
            <div className="overflow-hidden rounded-lg border">
              <AccountCommand
                accounts={accounts}
                favoriteAccountIds={favoriteAccountIds}
                onSelect={onSelect}
                onToggleFavorite={onToggleFavorite}
                autoFocus
              />
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
